/* eslint-disable class-methods-use-this */
import _ from 'lodash';
import handlerResponse from 'utils/handlerResponse';
import * as api from '../../../../utils/apiClient';
import {
  restructureUserFullInfo,
  restructureAccountFullInfo,
  restructureUserProfileForm,
  restructureUserModel
} from './restructuring';
import restructureResponse from '../../../../utils/restructureResponse';
import { restructureUserBlackListModel } from '../../../userBlackList/services/UserBlackListService/restructuring';
import { restructurePaginationModel } from '../../../../common/restructuring';

class UserService {
  async auth(state, params) {
    const response = await api.post('/user/auth', {}, params);
    const data = await response.json();
    return data;
  }

  async signup(state, params) {
    const response = await api.post('/user/signup', {}, params);
    const data = await response.json();
    return data;
  }

  async getMe(state) {
    const response = await api.get('/user/me', {
      expand:
        'profile.city_geo_name,count_stat,tasks_stat,rating_status,balance,referrer'
    });
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        restructureData: null
      };
    }
    return {
      response: responseJson,
      restructureData: restructureAccountFullInfo(state, responseJson)
    };
  }

  async getUserInfo(state, userId) {
    // console.log(queryParams);
    const response = await api.get(`/user/${userId}`, {
      expand:
        'profile.city_geo_name,count_stat,tasks_stat,rating_status,balance,referrer,outOfMyBlackListCustomer,outOfMyBlackListExecutor'
    });
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        userModel: _.keyBy(
          _.map([responseJson.data], item =>
            restructureUserFullInfo(state, item)
          ),
          'id'
        ),
        outOfMyBlackListCustomerModel: restructureUserBlackListModel(
          responseJson.data.outOfMyBlackListCustomer
        ),
        outOfMyBlackListExecutor: restructureUserBlackListModel(
          responseJson.data.outOfMyBlackListExecutor
        )
      }
    };
  }

  async updateMe(state, body) {
    const response = await api.put('/user/me', {}, body);
    const data = await response.json();
    return data;
  }

  async getUserById(state, userId) {
    const response = await api.get(`/user/${userId}`, {});
    const responseJson = await response.json();
    return restructureResponse(
      responseJson,
      responseJson,
      restructureUserProfileForm
    );
  }

  async getPublicUsers(state, queryParams) {
    const response = await api.get('/user/public-search', {
      expand: 'profile',
      ...queryParams
    });
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        itemsById: _.keyBy(
          _.map(responseJson.data.items, item =>
            restructureUserModel(state, item)
          ),
          'id'
        ),
        itemsIds: _.map(responseJson.data.items, item => item.id),
        pagination: restructurePaginationModel(
          _.get(responseJson, 'data._meta')
        )
      }
    };
  }

  async changePassword(state, body) {
    const response = await api.post('/user/change-password', {}, body);
    return handlerResponse(response);
  }

  async changePasswordApprove(body) {
    const response = await api.post('/user/change-password-approve', {}, body);
    return handlerResponse(response);
  }

  async confirmNewEmail(state, token) {
    const response = await api.get('/user/confirm-new-email', { token });
    const data = await response.json();
    return data;
  }

  async confirmChangeEmail(state, token) {
    const response = await api.get('/user/change-email', { token });
    const data = await response.json();
    return data;
  }

  async resendEmailConfirmToken() {
    const response = await api.get('/user/resend-email-confirm-token', {});
    const data = await response.json();
    return data;
  }

  async resendChangeEmailConfirmToken() {
    const response = await api.get(
      '/user/resend-change-email-confirm-token',
      {}
    );
    const data = await response.json();
    return data;
  }

  async cancelEmailChangeRequest() {
    const response = await api.get('/user/cancel-email-change-request', {});
    const data = await response.json();
    return data;
  }

  async authByToken(state, authToken) {
    const response = await api.post(`/user/token-auth/${authToken}`, {}, {});
    const data = await response.json();
    return data;
  }

  async requestPasswordReset(state, body) {
    const response = await api.post('/user/request-password-reset', {}, body);
    const data = await response.json();
    return data;
  }

  async changePasswordByToken(state, token, body) {
    const response = await api.post('/user/reset-password', { token }, body);
    const data = await response.json();
    return data;
  }

  async saveMetricsUid(state, gaUid, ymUid) {
    const response = await api.post('/user/save-metrics-uid', { gaUid, ymUid });
    const data = await response.json();
    return data;
  }

  async changeAuthType(body) {
    const response = await api.post(
      '/kernel/account/change-auth-type',
      {},
      body
    );
    const data = await response.json();
    return data;
  }
}

export default new UserService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/services/UserService/UserService.js